const duplicateTranslationKey = (key: string): string => key;

export const translationsDashboard_sv_part1 = {
  loadingConversations: "Laddar konversationer...",
  sidebarTitle: "Konversationer",
  goToLivechat: "Gå till livechat",
  livechatAvailable: "Den här konversationen är tillgänglig i livechat-läge...",
  showFilters: "Visa filter",
  hideFilters: "Dölj filter",
  clearFilters: "Rensa filter",
  remove: "Ta bort",
  refresh: "Uppdatera",
  filtersPanelTitle: "Filter",
  filtersPanelHint: "Begränsa listan och sök",
  quickFilters: "Snabbfilter",
  noToken: "Token hittades inte",
  bugStatus: "Felstatus",
  customerRating: "Kundbetyg",
  Tags: "Underämnen",
  Topic: "Ämne",
  topicArchivedLabel: "arkiverad",
  topicOtherOption: "Annat",
  conversationSyncDelayed: "Uppdateringar fördröjda. Återansluter…",
  uncategorized: "Okategoriserad konversation",
  noConvoSelected: "Välj en konversation för att se detaljer.",
  reported: "rapporterad",
  report: "Rapportera",
  internal: "intern",
  resolved: "löst",
  suggestion: "förslag",
  test_feedback: "test-feedback",
  ai_report: "AI-rapport",
  noStatus: "ingen",
  markResolved: "Markera som löst",
  removeStatus: "Ta bort felstatus",
  reportBug: "Rapportera fel",
  reportInternalBug: "Rapportera internt fel",
  reportSuggestion: "Rapportera förslag",
  reportCriticalBug: "Rapportera kritiskt fel",
  reportAdminBug: "Rapportera adminfel",
  reportAiReport: "AI-rapport",
  reportBugTooltip:
    "Använd för vanliga fel eller oväntat beteende i konversationen eller chatboten som ska dokumenteras.",
  reportInternalBugTooltip:
    "Använd för problem som huvudsakligen är relevanta internt för ert team – blockerar typiskt inte slutanvändare.",
  reportCriticalBugTooltip:
    "Använd för allvarliga fel som blockerar användare eller kräver snabb åtgärd.",
  reportAdminBugTooltip:
    "Använd för fel i dashboarden eller adminfunktioner (visas endast som adminrapporttyp).",
  reportAiReportTooltip:
    "Använd för rapporter inlämnade av AI-agenter (synliga endast för administratörer).",
  reportSuggestionTooltip: "Använd för förbättringsidéer – inte för fel eller trasigt beteende.",
  critical_bug: "kritiskt fel",
  admin_bug: "adminfel",
  userRating: "Användarbetyg",
  ratingFeedback: "Feedback",
  purchaseYes: "Den här användaren genomförde ett köp.",
  purchaseNo: "Den här användaren genomförde inget köp.",
  all: "Alla",
  date: "Datum",
  conversationID: "Konversations-ID",
  showBugReport: "Visa felrapport",
  hideBugReport: "Dölj felrapport",
  reportTypeOptions: "Välj rapporttyp eller lägg till kommentar",
  addCommentOrViewComments: "Lägg till kommentar / Visa kommentarer",
  translateButton: "Översätt",
  translatingButton: "Översätter...",
  selectLanguageOption: "Välj språk",
  thumbsUp: "Tumme upp",
  thumbsDown: "Tumme ned",
  unviewed: "Ej visad",
  markAsUnread: "Markera som oläst",
  delete: "Radera",
  conversationActions: "Konversationsåtgärder",
  view: "Vy",
  dashboardView: "Dashboard-vy",
  chatbotView: "Chatbot-vy",
  chatbotViewLoading: "Laddar chatbot-vy",
  chatbotViewLoadError: "Kunde inte läsa in chatbot-vyn.",
  chatbotViewRetry: "Försök igen",
  typeYourAnswer: "Skriv ditt svar här...",
  agentName: "Agentnamn",
  saveAgentName: "Spara agentnamn",
  previous: "Föregående",
  next: "Nästa",
  agentNameLabel: "Ditt agentnamn",
  agentNamePlaceholder: "Ange ditt agentnamn",
  agentNameSaved: "Agentnamn sparat!",
  searchConversationsPlaceholder: "Sök konversationer, ID:n eller användar-ID:n...",
  noConversationsMatchFilters: "Inga konversationer matchar dina filter.",
  noConversationsMatchFiltersHint:
    "Prova att rensa filter eller sök efter ett konversations-ID eller användar-ID.",
  conversationsLoadFailed: "Konversationerna kunde inte laddas.",
  conversationsLoadFailedHint:
    "Försök igen. Om det fortsätter att misslyckas, sök i färre chatbotar eller en kortare period.",
  noMessages: "Inga meddelanden ännu",
  endOfList: "Slut på listan",
  loadingMoreConversations: "Laddar fler konversationer",
  pageLabel: "Sida",
  userIDLabel: "Användar-ID",
  ligegyldigLabel: "Oväsentlig",
  ligegyldigYes: "Ja",
  ligegyldigNo: "Nej",
  freshdeskFormVisualOnly: "Det här är bara en visuell representation av kontaktformuläret",
  addNotesPlaceholder: "Lägg till anteckningar här...",
  freshdeskContactSupport: "Kontakta kundtjänst",
  freshdeskYourEmail: "Din e-post:",
  freshdeskEmailPlaceholder: "exempel@mail.com",
  freshdeskSupportMessage: "Meddelande till kundtjänst:",
  freshdeskMessagePlaceholder: "Skriv ditt meddelande här...",
  freshdeskUploadImageOptional: "Ladda upp bild (valfritt):",
  freshdeskChooseFile: "Välj fil",
  freshdeskNoFileChosen: "Ingen fil vald",
  freshdeskSendInquiry: "Skicka förfrågan",
  leadgenContactForm: "Kontaktformulär",
  contactFormSubmitted: "Kontaktformulär inskickat",
  originalFormDisplayUnavailable:
    "Den ursprungliga formulärvisningen registrerades inte för det här meddelandet.",
  contactFormSubmittedDescription: "Kunden fyllde i kontaktformuläret nedan.",
  livechatHandoverSent: "Skickat till livechat",
  livechatHandoverSentDescription: "Kunden accepterade överlämningen till en livechatt-agent.",
  livechatHandoverDeclined: "Livechat avböjd",
  livechatHandoverDeclinedDescription: "Kunden avböjde överlämningen till en livechatt-agent.",
  conversationLivechatStarted: "Livechatt startad",
  conversationLivechatEnded: "Livechatt avslutad",
  conversationLivechatEndedByCustomer: "Livechatt avslutad av kunden",
  conversationLivechatEndedByAgent: "Livechatt avslutad av agenten",
  conversationLivechatEndedInactivity: "Livechatt stängd efter inaktivitet",
  livechatPromptQuestionPlaceholder: "Vill du prata med en agent?",
  livechatPromptYesTextPlaceholder: "Ja tack",
  livechatPromptNoTextPlaceholder: "Nej tack",
  leadgenNameLabel: "Ditt namn",
  leadgenNamePlaceholder: "Ange ditt namn",
  leadgenEmailLabel: "Din e-post",
  leadgenEmailPlaceholder: "Ange din e-post",
  leadgenSubmitButton: "Skicka",
  leadgenFormVisualOnly: "Det här formuläret visas enbart i dashboarden",
  searchInfoChunks: "Sök i dina informationsbitar...",
  selectOption: "Välj alternativ",
  selectKnowledgebase: "Välj kunskapsbas",
  dateLabel: "Datum",
  purchaseLabel: "Köp",
  [duplicateTranslationKey("purchaseNo")]: "Inget köp",
  withPurchase: "Med köp",
  testConversationsFilter: "Test",
  testOriginFilterLabel: "Testkälla",
  testOriginAi: "AI",
  testOriginDashboard: "Dashboard",
  testOriginPortal: "Portal",
  testConversationBadgeAi: "Test (AI)",
  testConversationBadgeDashboard: "Test (Dashboard)",
  testConversationBadgePortal: "Test (Portal)",
  missingInfo: "Saknad info",
  missingInfoFilterApplied: "Visar konversationer med saknad info",
};
